import {$WS} from "../webSocketProtoHead";
import {MSG} from "../../proto/proto";
import {SUB} from "../wsProtoConfigBase";

export interface MsgBody {
    userId: string;
}

export default class CSubLoginServer implements $WS.WebSocketProtoHeadBody {
    //协议头
    static readonly HEAD: number = SUB.CSubLoginServer;
    //
    readonly head: number;
    body: MsgBody;

    constructor(userId: string) {
        this.head = CSubLoginServer.HEAD;
        this.body = {userId};
    }

    getPackageBody(): Uint8Array {
        let obj = $WS.getHallGameProtoHeadObject(this.head, $WS.ProtoHead.HALL);
        obj = Object.assign(obj, this.body);
        return MSG.CSubLoginServer.encode(obj).finish();
    }

    static unPackageMessage(message: Uint8Array): CSubLoginServer {
        const msg: any = MSG.CSubLoginServer.decode(message);
        const res = <MsgBody>msg;
        return new CSubLoginServer(res.userId);
    }
}